import React from "react";
import { Col, Hr } from "@amzn/stencil-react-components/layout";
import { AttachmentType, AttachmentSubType } from "../models";
import { Text } from "../../../../components/typography";
import useArb from "../../../../hooks/use-arb";
import { DocumentUploadComplete } from "./document-upload-complete";
import { DocumentUploadNeeded } from "./document-upload-needed";
import { StatusEnum } from "../../../../hoc/with-status";

interface DocumentsCompletedParams {
  sides: string[];
  document: AttachmentType;
  status: StatusEnum;
}

interface DocConfig {
  documentName: string;
  documentMessage: string;
  backOptional?: boolean;
}

export const DocumentCompletedUploadFrontBack = ({
  sides,
  document,
  status,
}: DocumentsCompletedParams) => {
  const bundle = useArb("HVHChecklistPantherResource");
  const documentFrontTitle = bundle.getMessage(
    "Checklist-Document-Front-Title"
  );
  const documentBackTitle = bundle.getMessage("Checklist-Document-Back-Title");
  const curpIdUploadMessage = bundle.getMessage(
    "Checklist-Mainpage-CURP-ID-Upload-ButtonText"
  );
  const ineUploadMessage = bundle.getMessage(
    "Checklist-MainPage-INE-Upload-ButtonText"
  );
  const curpIdTitleMessage = bundle.getMessage(
    "Checklist-MainPage-CURP-ID-Title"
  );
  const ineTitleMessage = bundle.getMessage("Checklist-MainPage-INE-Title");
  const documentConfig: Record<string, DocConfig> = {
    [AttachmentType.CURP]: {
      documentName: curpIdTitleMessage,
      documentMessage: curpIdUploadMessage,
      backOptional: true,
    },
    [AttachmentType.INE]: {
      documentName: ineTitleMessage,
      documentMessage: ineUploadMessage,
    },
  };
  const currentDocumentData = documentConfig[document];
  const front =
    sides.indexOf(AttachmentSubType.FRONT) > -1
      ? DocumentUploadComplete({ documentType: document, status: status })
      : DocumentUploadNeeded({
          documentType: document,
          documentMessage: currentDocumentData.documentMessage,
          status: status,
        });

  const back =
    sides.indexOf(AttachmentSubType.BACK) > -1
      ? DocumentUploadComplete({ documentType: document, status: status })
      : DocumentUploadNeeded({
          documentType: document,
          documentMessage: currentDocumentData.documentMessage,
          optional: currentDocumentData.backOptional,
          status: status,
        });

  return (
    <Col gridGap={16}>
      <Text>{`${currentDocumentData.documentName} - ${documentFrontTitle} `}</Text>
      {front}
      <Hr />
      <Text>{`${currentDocumentData.documentName} - ${documentBackTitle} `}</Text>
      {back}
      <Hr />
    </Col>
  );
};
